import React from "react";

// Files attached to a course — supports the new multi-file list and the legacy single info_file.
export const courseFiles = (c) => (c?.info_files?.length ? c.info_files : (c?.info_file ? [c.info_file] : []));

// Inline parser: **bold** and *italic* only. Never renders raw HTML (XSS-safe).
function inline(text, keyBase) {
  const parts = [];
  const regex = /(\*\*[^*]+\*\*|\*[^*]+\*)/g;
  let last = 0, m, i = 0;
  while ((m = regex.exec(text))) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    const t = m[0];
    if (t.startsWith("**")) parts.push(<strong key={`${keyBase}-${i++}`}>{t.slice(2, -2)}</strong>);
    else parts.push(<em key={`${keyBase}-${i++}`}>{t.slice(1, -1)}</em>);
    last = regex.lastIndex;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}

// Lightweight markdown: # / ## headings, - / * bullet lists, **bold**, *italic*, paragraphs.
export function MarkdownLite({ text, className, style }) {
  if (!text || !text.trim()) return null;
  const lines = text.split("\n");
  const blocks = [];
  let list = null;
  const flush = () => { if (list) { blocks.push({ type: "ul", items: list }); list = null; } };
  lines.forEach((raw) => {
    const line = raw.replace(/\s+$/, "");
    if (/^\s*[-*]\s+/.test(line)) { (list = list || []).push(line.replace(/^\s*[-*]\s+/, "")); return; }
    flush();
    if (/^#{1,2}\s+/.test(line)) {
      const level = line.match(/^(#{1,2})/)[1].length;
      blocks.push({ type: "h", level, text: line.replace(/^#{1,2}\s+/, "") });
    } else if (line.trim() === "") {
      // blank line: paragraph break handled via margins
    } else {
      blocks.push({ type: "p", text: line });
    }
  });
  flush();
  return (
    <div className={className} style={style}>
      {blocks.map((b, i) => {
        if (b.type === "h") return b.level === 1
          ? <h3 key={i} className="font-head text-base font-bold mt-3 mb-1 first:mt-0">{inline(b.text, `h${i}`)}</h3>
          : <h4 key={i} className="font-semibold text-sm mt-2.5 mb-1 first:mt-0">{inline(b.text, `h${i}`)}</h4>;
        if (b.type === "ul") return <ul key={i} className="list-disc pl-5 space-y-0.5 my-1.5">{b.items.map((it, j) => <li key={j}>{inline(it, `l${i}-${j}`)}</li>)}</ul>;
        return <p key={i} className="my-1.5 first:mt-0 whitespace-pre-wrap leading-relaxed">{inline(b.text, `p${i}`)}</p>;
      })}
    </div>
  );
}
